import { useNavigate } from 'react-router-dom'
import { useEventFetcher } from './useEventFetcher'
import { useEventArtists } from './useEventArtists'
import { useEventMedia } from './useEventMedia'
import { useThemeDetection } from './useThemeDetection'

export const useEventDetail = (eventId, user) => {
  const navigate = useNavigate()
  const { event, setEvent, loading, error: fetchError } = useEventFetcher(eventId)
  const mediaHandlers = useEventMedia(setEvent)
  const artistHandlers = useEventArtists(eventId, event, setEvent, user)
  const { isClearTheme } = useThemeDetection()



  const handleEditEvent = () => {
    navigate(`/editEvent/${event._id}`)
  }

  return {
    event,
    // Exposed so callers that already hold an updated event (the flyer-update
    // apply response) can refresh the page without a second round trip.
    setEvent,
    loading,
    error: fetchError || mediaHandlers.error || artistHandlers.error,
    success: mediaHandlers.success,
    isClearTheme,
    handleEditEvent,
    ...mediaHandlers,
    ...artistHandlers
  }
}